import { AxiosResponse } from 'axios';
import api from '~/utils/api';

export async function getBillPdf(cd_fatura: string): Promise<AxiosResponse> {
  return api.get('/boletos/download', {
    params: {
      cd_fatura,
    },
    headers: {
      'Content-Type': 'application/pdf',
    },
    // responseType: 'blob',
  });
}
